import type { PriceDetailType } from '../../../../types';

export const getPrefix = (type: PriceDetailType['type']) => {
  switch (type) {
    case 'extra':
      return '+';
    case 'cashback':
      return '-';
    case 'basic':
    default:
      return '';
  }
};
